<template>
  <core-btn color="primary" :href="computedUrl" :title="label">
    {{ label }}
  </core-btn>
</template>

<script>
import searchMixin from '@/mixins/search/';
import param from '@/helpers/param';
import queryBuilder from '@/helpers/search-client/query-builder/query';

export default {
  name: 'SearchButton',
  isCustomElement: true,
  mixins: [searchMixin],
  components: {},
  props: {
    url: {
      type: String,
      default: '',
      required: false,
    },
  },
  computed: {
    label() {
      return this.$tc('SEARCH.BUTTON_SEARCH', this.formatNumber(this.state('search.foundVehiclesCount')));
    },
    computedPath() {
      const listingUrl = this.getters('app/getListingUrl');
      const path = this.url || listingUrl;
      if (/^http/.test(path)) return path.replace(/\/$/, '');
      const url = this.state('app.context.site.url');
      const href = `${url}/${path.replace(/^\//, '')}`;
      return href;
    },
    computedUrl() {
      const path = this.computedPath;
      if (!this.state('search')) return path;
      const searchParams = this.state('search.searchCriteria');
      const { query } = queryBuilder.serializeObjToQuery(searchParams);
      const newSearchString = param(query);
      if (newSearchString) return `${path}?${newSearchString}`;
      return path;
    },
  },
  methods: {
    afterModulesLoaded() {
      // load the count to show within the button if the count does not already exist
      if (this.state('search.foundVehiclesCount')) return;
      this.dispatch('search/getCount');
    },
  },
};
</script>
